import * as React from "react"
import Svg, { Path } from "react-native-svg"

const SVGFavoris = (props) => (
  <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" {...props}>
    <Path d="M26.75 4.71v2c3.11 0 6.18 2.16 7.46 5.25.69 1.66 1.36 4.91-1.85 8.12L19.99 32.46 7.63 20.08c-3.21-3.21-2.53-6.46-1.85-8.12 1.28-3.09 4.35-5.25 7.47-5.25 1.91 0 3.69.79 5.29 2.37l.05.05L20 10.54l1.41-1.41.06-.06c1.59-1.56 3.36-2.36 5.28-2.36v-2m0 0c-2.25 0-4.58.87-6.68 2.93l-.07.07-.07-.07c-2.1-2.06-4.44-2.93-6.68-2.93-7.54 0-14.06 9.76-7.04 16.79l13.71 13.73.07.07.07-.07L33.77 21.5c7.02-7.02.51-16.79-7.03-16.79Z" />
  </Svg>
)

export default SVGFavoris;